import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ClosedcaptionsIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M7.93274 12C7.93274 10.0845 10.0754 10.1661 10.417 11.4203H11.7197C11.2412 8.48798 6.63055 8.68848 6.63055 12C6.63055 15.4013 11.3526 15.431 11.7338 12.5504H10.4452C10.1348 13.8642 7.93274 13.8865 7.93274 12ZM13.519 12C13.519 10.0845 15.6617 10.1661 16.0033 11.4203H17.306C16.8275 8.48798 12.2168 8.68848 12.2168 12C12.2168 15.4013 16.9389 15.431 17.3201 12.5504H16.0316C15.7211 13.8642 13.519 13.8865 13.519 12ZM17.38 5H6.62C4.85999 5 3.85999 6 3.85999 7.76001V16.24C3.85999 18 4.85999 19 6.62 19H17.38C19.14 19 20.14 18 20.14 16.24V7.76001C20.14 6 19.14 5 17.38 5H17.38ZM18.5 16.14C18.5 16.84 17.98 17.36 17.28 17.36H6.71997C6.02002 17.36 5.5 16.84 5.5 16.14V7.85999C5.5 7.15998 6.02002 6.64002 6.71997 6.64002H17.28C17.98 6.64002 18.5 7.15998 18.5 7.85999V16.14V16.14Z"
      />
    </SvgIcon>
  );
});
